export default function IteratorPage() {
  return (
    <ul>
      <li>Iterator: </li>
    </ul>
  );
}
